export enum LOCATION_CONSTANT {
    PRE_POLLING_SECTION_TITLE = 'Location for Pre-polling Booth Days',
    ELECTION_SECTION_TITLE = 'Location for Polling Day',
}
